<template>
  <v-row
    align-center
    justify-center
    class="docs ma-3"
  >
    <v-col xs8>
      <v-card class="pa-4 docs-card">
        <v-card-title primary-title>
          <div>
            <h1>
              Terms of Service
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    color="warning"
                    text-color="white"
                    small
                    class="ml-2 align-middle"
                    v-bind="attrs"
                    v-on="on"
                  >
                    DRAFT
                  </v-chip>
                </template>
                <span>Pending Legal Review &mdash; not approved, not in
                  effect, and not binding until Legal signs off.</span>
              </v-tooltip>
            </h1>
            <p class="caption mb-0 mt-1">
              This is a starting draft only, not yet reviewed or approved by
              Legal.
            </p>
          </div>
        </v-card-title>

        <v-card-text>
          <p>
            These Terms of Service (“Terms”) govern your access to and use
            of iAdOps (the “Service”), a web application owned and operated
            by Outsourced Ad Ops, LLC, a New York limited liability company,
            d/b/a adops.com (“OAO,” “we,” “us,” or “our”). By accessing or
            using the Service, you agree to be bound by these Terms. If you
            do not agree, do not use the Service.
          </p>

          <h2>
            1. DESCRIPTION OF THE SERVICE
          </h2>

          <p>
            iAdOps is an ad operations platform. It gives publishers and
            OAO's ad operations team a single interface to monitor ad
            delivery pacing, reconcile discrepancies, and track revenue
            performance across advertising networks such as Google Ad
            Manager.
          </p>

          <h2>
            2. ELIGIBILITY AND ACCOUNTS
          </h2>

          <p>
            The Service is intended for use by OAO's clients, their
            authorized personnel, and OAO's own internal personnel, each
            acting in a business capacity. You are responsible for
            maintaining the confidentiality of your account credentials and
            for all activity that occurs under your account. Notify OAO
            promptly at <a href="mailto:tech@adops.com">tech@adops.com</a>
            of any unauthorized use of your account.
          </p>

          <h2>
            3. GOOGLE SIGN-IN
          </h2>

          <p>
            The Service supports signing in with your Google account.
            Signing in with Google is used only to verify your identity and
            grant you secure access to the Service. For most users, this
            means OAO requests only your basic Google profile and email
            address. Certain internal OAO accounts may additionally connect
            limited, read-only access to Google Sheets and Drive to support
            internal reporting workflows. OAO does not access your Gmail or
            any other personal Google data beyond what is described here
            and in our
            <router-link to="/privacy-policy">
              Privacy Policy
            </router-link>.
          </p>

          <h2>
            4. ACCEPTABLE USE
          </h2>

          <p>
            You agree to use the Service only for its intended business
            purpose and in compliance with applicable law. You will not:
            (a) attempt to gain unauthorized access to the Service or any
            other user's account or data; (b) interfere with or disrupt the
            integrity or performance of the Service; (c) use the Service to
            transmit unlawful, infringing, or harmful content; or (d)
            reverse engineer, decompile, or attempt to extract the source
            code of the Service, except to the extent such restriction is
            prohibited by applicable law.
          </p>

          <h2>
            5. DATA AND CONFIDENTIALITY
          </h2>

          <p>
            The Service may display or process data belonging to you or
            your organization, including advertising performance and
            delivery data. You retain ownership of your data. OAO will
            handle personal information in accordance with our
            <router-link to="/privacy-policy">
              Privacy Policy
            </router-link>. Where OAO processes personal information on
            behalf of a client organization under a separate written
            agreement (including any data processing addendum), the terms
            of that agreement govern to the extent they address the
            processing of that organization's personal information.
          </p>

          <h2>
            6. INTELLECTUAL PROPERTY
          </h2>

          <p>
            The Service, including its software, design, and underlying
            technology, is owned by OAO and protected by applicable
            intellectual property laws. These Terms do not grant you any
            ownership interest in the Service. You are granted a limited,
            non-exclusive, non-transferable right to access and use the
            Service for its intended business purpose during the term of
            your authorized access.
          </p>

          <h2>
            7. THIRD-PARTY SERVICES
          </h2>

          <p>
            The Service integrates with third-party platforms, including
            Google Ad Manager and Google Sign-In. OAO is not responsible
            for the availability, accuracy, or practices of third-party
            platforms, which are governed by their own terms.
          </p>

          <h2>
            8. DISCLAIMER OF WARRANTIES
          </h2>

          <p>
            THE SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE,” WITHOUT
            WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE, OR NON-INFRINGEMENT.
          </p>

          <h2>
            9. LIMITATION OF LIABILITY
          </h2>

          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, OAO WILL NOT BE LIABLE
            FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR
            PUNITIVE DAMAGES ARISING OUT OF YOUR USE OF THE SERVICE.
          </p>

          <h2>
            10. TERMINATION
          </h2>

          <p>
            OAO may suspend or terminate your access to the Service at any
            time, including if you violate these Terms. Upon termination,
            your right to use the Service ceases immediately.
          </p>

          <h2>
            11. CHANGES TO THESE TERMS
          </h2>

          <p>
            OAO may update these Terms from time to time. Material changes
            will be reflected by an updated effective date below. Continued
            use of the Service after changes take effect constitutes
            acceptance of the revised Terms.
          </p>

          <h2>
            12. GOVERNING LAW
          </h2>

          <p>
            These Terms are governed by the laws of the State of New York,
            without regard to its conflict of laws principles. Any dispute
            arising under these Terms will be subject to the exclusive
            jurisdiction of the state and federal courts located in New
            York, New York.
          </p>

          <h2>
            13. CONTACT
          </h2>

          <p>
            Questions about these Terms can be directed to
            <a href="mailto:tech@adops.com">tech@adops.com</a>.
          </p>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'TermsOfService',
}
</script>

<style lang="scss" scoped>
@import "~src/styles/variables";
</style>
